import React from 'react';
import ArticleIntro from './ArticleIntro';
import ArticleTableOfContent from './ArticleTableOfContent';
import ArticleBlog from './ArticleBlog';
import ArticleKeyTakeaways from './ArticleKeyTakeaways';
import ArticleFAQ from './ArticleFAQ';
import RelatedProducts from '../RelatedProducts/RelatedProducts';
import ArticleReferences from './ArticleReferences';
import ArticleAuthor from './ArticleAuthor';
import ArticleAdditionalReading from './ArticleAdditionalReading';
import ArticleSignup from './ArticleSignUp';

interface ArticleMobileLayoutProps {
  intro?: string;
  introClassname?: string;
  lastUpdatedDate?: string;
  tableOfContent?: object;
  blogContent?: object;
  keyTakeawaysContent?: object;
  childrenMobile?: React.ReactNode;
  faqContent?: object;
  activeIndex?: number;
  topicIndex?: number;
  relatedProducts?: object[];
  isMobile: boolean;
  onClickCallback?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isArticle?: boolean;
  rightArrowIconArticle?: any;
  leftArrowIconArticle?: any;
  references?: object;
  authorContent?: object;
  relatedArticles?: object[];
  signupContent?: object;
}

const ArticleMobileLayout: React.FC<ArticleMobileLayoutProps> = ({
  intro,
  introClassname,
  lastUpdatedDate,
  tableOfContent,
  blogContent,
  keyTakeawaysContent,
  childrenMobile,
  faqContent,
  activeIndex = 0,
  topicIndex = -1,
  relatedProducts,
  isMobile,
  onClickCallback,
  isArticle,
  rightArrowIconArticle,
  leftArrowIconArticle,
  references,
  authorContent,
  relatedArticles,
  signupContent,
}) => (
  <div className="mobile-articlebody-section pb-5">
    {intro && (
      <ArticleIntro
        introContent={intro}
        introClassname={introClassname}
        lastUpdatedDate={lastUpdatedDate}
      />
    )}
    {tableOfContent && (
      <ArticleTableOfContent
        tableOfContent={tableOfContent}
        isMobile={isMobile}
      />
    )}
    {blogContent && (
      <ArticleBlog blogContent={blogContent} isMobile={isMobile} />
    )}
    {keyTakeawaysContent && (
      <ArticleKeyTakeaways
        keyTakeawaysContent={keyTakeawaysContent}
        isMobile={isMobile}
      />
    )}
    <div className="articlebody-section w-full px-2h py-3 text-left">
      {childrenMobile}
    </div>
    {faqContent && (
      <ArticleFAQ
        faqContent={faqContent}
        activeIndex={activeIndex}
        topicIndex={topicIndex}
      />
    )}
    {relatedProducts && relatedProducts.length > 0 && (
      <RelatedProducts
        products={relatedProducts}
        isMobile={isMobile}
        onClickCallback={onClickCallback || (() => {})}
        isArticle={!!isArticle}
        rightArrowIconArticle={rightArrowIconArticle}
        leftArrowIconArticle={leftArrowIconArticle}
      />
    )}
    {references && <ArticleReferences references={references} />}
    {authorContent && <ArticleAuthor authorContent={authorContent} />}
    {relatedArticles && relatedArticles.length > 0 && (
      <ArticleAdditionalReading
        articles={relatedArticles}
        isMobile={!!isMobile}
        rightArrowIconArticle={rightArrowIconArticle}
        leftArrowIconArticle={leftArrowIconArticle}
      />
    )}
    {signupContent && <ArticleSignup signupContent={signupContent} />}
  </div>
);

export default ArticleMobileLayout;